/**
 * Javascript for loading animations based on Intersection Observer.
 * 
 * @since 1.0.0
 */
export { animationLoader, aniActiveEvent };

const aniActiveEvent = new Event( 'aniActive' );

class animationLoader {
  selector = '.ani';
  ioOptions = {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: 0.33
  };
  killSwitch = true;
	setDelays = false;
  aniObjects;
  aniObserver;

  
  constructor( selector, ioOptions, killSwitch, setDelays ){
    if( selector !== undefined ){
      this.selector = selector;
    }
    
    if ( ioOptions !== undefined ) {
      // merge objects using spread syntax
      this.ioOptions = { ...this.ioOptions, ...ioOptions };
    }

    if( killSwitch !== undefined ){
      this.killSwitch = killSwitch;
    }

    if( setDelays !== undefined ){
      this.setDelays = setDelays;
    }

		this.setDelays = true;

    this.aniObjects = document.querySelectorAll( this.selector );
    
    if( true === this.killSwitch ){
      this.aniObserver = new IntersectionObserver( this.aniCallbackOnce, this.ioOptions );
    }
    else {
      this.aniObserver = new IntersectionObserver( this.aniCallbackContinuous, this.ioOptions );
    }
    
    window.addEventListener( "load", ( event ) => {
			let counter = 0;
      this.aniObjects.forEach( obj => {
				if ( true === this.setDelays ) {
					obj.style.animationDelay = ( counter * 0.333 ) + 's';
					counter++;
				}
        this.aniObserver.observe( obj );
      } );

    }, false );
  }

  /**
   * Animation callback that stops after one intersection
   * 
   * @param {DOM element} entries 
   * @param {object} observer IntersectionObserver object
   */
  aniCallbackOnce( thisObj, thisObserver ) {
    thisObj.forEach( function ( obj, index ) {

      if ( obj.isIntersecting ) {
				console.log("🚀 ~ animationLoader ~ aniCallbackOnce ~ obj:", obj.target)
        obj.target.classList.add( 'active' );
        obj.target.dispatchEvent( aniActiveEvent );
        thisObserver.unobserve( obj.target );
      }

    } );
  }

  /**
 * Animation callback
 * 
 * @param {DOM element} entries 
 * @param {object} observer IntersectionObserver object
 */
  aniCallbackContinuous( thisObj, thisObserver ) {
    thisObj.forEach( function ( obj, index ) {

      if ( obj.isIntersecting ) {
				console.log("🚀 ~ animationLoader ~ aniCallbackOnce ~ obj:", obj.target)
        obj.target.classList.add( 'active' );
        obj.target.dispatchEvent( aniActiveEvent );
      }
      else {
        obj.target.classList.remove( 'active' );
      }

    } );
  }
}